/* eslint-disable prefer-arrow-callback*/
$(function () {
  $('.accordion-parent').on('click', function () {
    $(this).next().slideToggle();
    $(this).toggleClass("selected");
  });
});
/* eslint-disable prefer-arrow-callback*/
